import { request, API_V1_PREFIX } from "./client";
import type { ClassData } from "./types";

export async function getClasses(
  token: string,
  schoolProfileId?: string,
): Promise<ClassData[]> {
  const query = schoolProfileId ? `?school_profile_id=${schoolProfileId}` : "";
  return request<ClassData[]>(
    `${API_V1_PREFIX}/classes${query}`,
    { method: "GET" },
    { token },
  );
}

export async function createClass(
  data: Omit<ClassData, "id">,
  token: string,
): Promise<ClassData> {
  return request<ClassData>(
    `${API_V1_PREFIX}/classes`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function updateClass(
  id: string,
  data: Partial<ClassData>,
  token: string,
): Promise<ClassData> {
  return request<ClassData>(
    `${API_V1_PREFIX}/classes/${id}`,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
    { token },
  );
}

export async function deleteClass(id: string, token: string): Promise<boolean> {
  return request<boolean>(
    `${API_V1_PREFIX}/classes/${id}`,
    { method: "DELETE" },
    { token },
  );
}
